// DR volmacht/carrier code — K781 everywhere it always was (calc envelope via
// PRODUCT_REGISTRY.carrierCode, calcMethod URL, VE/VL_MYAAND, and the PP_AFDDEFN definition
// name). Live-tested 2026-07-07: deriving these from P413 breaks the engine — the ADN
// definition is registered under the K781 name, so the calculate stops working entirely.
export const DOORLOPENDE_REIS_CARRIER = 'K781';

// TEMP (2026-07-07): risicodrager/maatschappij UNDER TEST at user request — P413 is sent in
// PP_MYAAND + PP_MYNAAM ONLY (baselines carried PP_MYAAND 'K781' and PP_MYNAAM ''). Everything
// else stays K781 (see above). Revert HERE to 'K781'/'' if the test fails.
export const DOORLOPENDE_REIS_MYAAND = 'P413';

// Beroepsmilitair on the DR coverage. The question was dropped from this product's UI, but the
// backend still needs the answer on every document (calculate payload, offer chain, final
// request): always 'N'. One constant so the wire touchpoints cannot drift.
export const DOORLOPENDE_REIS_MVZBMIL = 'N';

export const DOORLOPENDE_REIS_PRODUCT = {
  carrier: DOORLOPENDE_REIS_CARRIER,
  productName: 'SAA DFD Reisverzekering',
  calcMethod: `api/v1/Products/Calculate/${DOORLOPENDE_REIS_CARRIER}/SAA DFD Reisverzekering/accept.new`,
} as const;

export const DOORLOPENDE_REIS_DEFAULTS: Record<string, string | number> = {
  OD_PPRC: 20,
  OD_COMBINA: '1', // fixed: the BFF doesn't price on this, so it's not asked on screen (maps to DR_COMBINA)
  VE_MYAAND: DOORLOPENDE_REIS_CARRIER,
  PP_MYAAND: DOORLOPENDE_REIS_MYAAND,
  PP_MYNAAM: DOORLOPENDE_REIS_MYAAND,
  PP_BRANCHE: '601', // ADN branchecode for SAA DFD Reisverzekering (per product schema default)
  PP_AFDDEFN: `601-${DOORLOPENDE_REIS_CARRIER}-SAA DFD Reisverzekering`, // AFD definitienaam (per product schema default)
  PP_POLPKJN: 'J', // Polis onderdeel van een pakket — tells the BFF to group DR into the Pakket
  PP_STPRV: 'J',
  PP_HANDACC: 'N',
  PP_SLOTAKK: 'N',
  PP_BETTERM: 1,
  PP_CDUUMND: 12,
  PP_BTWCD: 'I',
  Ongevallen: 'J',
};

// Request/enrich-path PP defaults (final documents only). Deliberately NOT part of
// DOORLOPENDE_REIS_DEFAULTS beyond what that map already carries: buildDfdDocument
// spreads that map into every calculate payload, which is golden-baselined and must not
// silently gain fields. Both wire touchpoints (summary/enrich.ts and ConfirmationScreen)
// apply this same record via applyPpDefaults.
export const DOORLOPENDE_REIS_PP_REQUEST_DEFAULTS: Record<string, string | number> = {
  PP_SPECLIM: 'N',
  PP_CDUUMND: DOORLOPENDE_REIS_DEFAULTS.PP_CDUUMND,
  PP_BTWCD: DOORLOPENDE_REIS_DEFAULTS.PP_BTWCD,
};

export const DOORLOPENDE_REIS_REQUIRED_FIELDS = [
  'OD_GSS', // Gezinssamenstelling
] as const;

export interface SelectOption {
  value: string | number;
  labelKey?: string;
  label: string;
}

export interface FieldDef {
  key: string;
  labelKey: string;
  fallbackLabel: string;
  options: SelectOption[];
}

export const FAMILY_COMPOSITION_FIELD: FieldDef = {
  key: 'OD_GSS',
  labelKey: 'common.personalInfo.familyComposition',
  fallbackLabel: 'Gezinssamenstelling',
  options: [
    { value: 'A', labelKey: 'common.familyComposition.A', label: 'Alleenstaande zonder kind(eren)' },
    { value: 'H', labelKey: 'common.familyComposition.H', label: 'Gezin zonder kind(eren)' },
    { value: 'I', labelKey: 'common.familyComposition.I', label: 'Gezin met kind(eren)' },
    { value: 'K', labelKey: 'common.familyComposition.K', label: 'Alleenstaande met kind(eren)' },
  ],
};


